module.exports = __webpack_public_path__ + "static/media/tiled-green-card.b300c3f2.png";